export const getAccessToken = (): string => localStorage.getItem('access') || '';
export const getRefreshToken = (): string => localStorage.getItem('refresh') || '';
